/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ToolPencilLineIcon16Light } from './ToolPencilLineIcon16Light';
import { ToolPencilLineIcon16Regular } from './ToolPencilLineIcon16Regular';
import { ToolPencilLineIcon16Solid } from './ToolPencilLineIcon16Solid';
import { ToolPencilLineIcon20Light } from './ToolPencilLineIcon20Light';
import { ToolPencilLineIcon20Regular } from './ToolPencilLineIcon20Regular';
import { ToolPencilLineIcon20Solid } from './ToolPencilLineIcon20Solid';
import { ToolPencilLineIcon24Regular } from './ToolPencilLineIcon24Regular';
import { ToolPencilLineIcon24Solid } from './ToolPencilLineIcon24Solid';
import { ToolPencilLineIcon32Regular } from './ToolPencilLineIcon32Regular';
import { ToolPencilLineIcon64Regular } from './ToolPencilLineIcon64Regular';
var sizes = {
    16: {
        light: ToolPencilLineIcon16Light,
        regular: ToolPencilLineIcon16Regular,
        solid: ToolPencilLineIcon16Solid,
    },
    20: {
        light: ToolPencilLineIcon20Light,
        regular: ToolPencilLineIcon20Regular,
        solid: ToolPencilLineIcon20Solid,
    },
    24: {
        regular: ToolPencilLineIcon24Regular,
        solid: ToolPencilLineIcon24Solid,
    },
    32: {
        regular: ToolPencilLineIcon32Regular,
    },
    64: {
        regular: ToolPencilLineIcon64Regular,
    },
};
export var ToolPencilLineIcon = forwardRef('ToolPencilLineIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
